import { t } from 'i18next';

import partnerLogo from '../styles/assets/images/musicstyling.png';
import partnerLogoDark from '../styles/assets/images/musicstyling-dark.png';
import { useBrandTheme } from './useBrandTheme';

const partner = {
  name: 'Musicstyling Ltd',
  url: 'https://www.musicstyling.com'
};

// White logo on dark themes, `-dark` (black) logo on light themes. The two
// files have different vertical padding, so they only match when sized by width.
export const PartnerLogo = ({ className = 'w-36' }) => {
  const { isDark } = useBrandTheme();

  return (
    <a href={partner.url} target="_blank" rel="noopener noreferrer" className="inline-block">
      <img src={isDark ? partnerLogo : partnerLogoDark} alt="Musicstyling" className={`h-auto max-w-full ${className}`} />
    </a>
  );
};

export const Copyright = ({ className = '' }) => (
  <span className={className}>
    {t('musicstyling.copyright_prefix', { year: new Date().getFullYear() })}{' '}
    <a href={partner.url} target="_blank" rel="noopener noreferrer" className="text-ms-accent hover:underline">
      {partner.name}
    </a>
  </span>
);
